import { FormattedMessage } from 'react-intl';
import { Box, Heading } from '../../../components';
import { useSystem } from '../../../lib/core/useSystem';
import { PaymentMethods } from './PaymentMethods';

const CreditCards = () => {
  const { paymentProvider } = useSystem();

  if (!paymentProvider) {
    return null;
  }

  return (
    <>
      <Box data-testid="Profile__CreditCards" mb={6}>
        <Heading mb={6} textAlign="center">
          <FormattedMessage
            id="modules.Profile.CreditCards.title"
            defaultMessage="Payment card"
          />
        </Heading>
        <PaymentMethods />
      </Box>
    </>
  );
};

export default CreditCards;
